import { assign } from '../../../../shared/Assign';
import * as types from '../actions/SE360ActionTypes';
import InitialState from './SE360InitialState';

export default function photographerBookingReducer(
    state: any = InitialState.photographers,
    action: { type: string; result: any; error: any }
) {
    let newState;

    switch (action.type) {
        case types.SE360_GET_PHOTOGRAPHERBOOKING_SUCCESS:
            newState = assign({}, state);
            newState.photographerCalendars = action.result.photographerBookingDtos;
            newState.availableRegions = action.result.availableRegions;
            newState.defaultRegionId = action.result.regionId;
            newState.orderInfo = action.result.orderInfo;
            newState.errors = action.result.errors;
            newState.bookableOnlyBySE360 = action.result.bookableOnlyBySE360;
            newState.selectedDate = action.result.selectedDate;
            newState.isManualBooking = action.result.isManualBooking;
            newState.allowedToLetSE360Book = action.result.allowedToLetSE360Book;
            newState.locationData = null;
            return newState;

        case types.SAVE_ADDRESS_POINT_LOCATION_FOR_BOOKING_SUCCESS:
            newState = assign({}, state);
            if (action.result) {
                newState.addressPointLocation = {
                    latitude: action.result.latitude,
                    longitude: action.result.longitude
                };
            }
            return newState;

        case types.CLEAR_ADDRESS_POINT_LOCATION_FOR_BOOKING_SUCCESS:
            newState = assign({}, state);
            newState.addressPointLocation = null;
            return newState;

        case types.SE360_GET_LOCATIONDATA_SUCCESS:
            newState = assign({}, state);
            newState.locationData = action.result;
            return newState;

        case types.SE360_GET_LOCATIONDATA_ERROR:
            newState = assign({}, state);
            newState.locationData = action.error;
            return newState;

        default:
            return state;
    }
}
